// extracted by mini-css-extract-plugin
module.exports = {"mergeDialog":"MergeDialog_mergeDialog__2KlEF"};